module.exports = __webpack_public_path__ + "static/media/skg_613-IG.ee864da3.PNG";